module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame04-e409745f276922dabf44c742177ba140.png";